import { BidView } from '../views/index';

export const BidViewTemplate: BidView = {
	origin: 'Origin:',
	destination: 'Destination:',
	trailerType: 'Trailer Type:',
	weight: 'Weight (lbs.):',
	approximateMiles: 'Approximate Miles:',
	commodity: 'Commodity:',
	expectedPickup: 'Expected Pickup:',
	expectedDelivery: 'Expected Delivery:',
	c4LoadNumber: 'C4 Load Number:',
	ourClient: 'Our Client:',
	specialInstructions: 'Special Instructions:',
	offeredPrice: 'Offered Price:',
};
